export default "__VITE_ASSET__AH8fsLUU__"